import clsx from "clsx";
import React, { useEffect, useState } from "react";
import CommonButton from "../../../Button";
import CommonTextArea from "../../../TextArea";

type Props = {
  editMode?: boolean;
  onChange: (text: string) => void;
  feedback?: string;
};

export default function ManagerReportFeedbackRecommend({
  editMode,
  onChange,
  feedback,
}: Props) {
  const [feedbackIndex, setFeedbackIndex] = useState<number>(-1);
  const feedbackList = [
    "안녕하세요. 샌디매니저입니다. 요청하신 사항에 대하여 처리완료하였습니다. 쾌적한 공간에서 오늘도 즐거운 하루 보내세요!",
    "안녕하세요. 샌디매니저입니다. 요청하신 사항에 대해 현재 이상이 없음을 확인했습니다. 지속 모니터링을 통해 재발방지를 위해 노력하겠습니다. 오늘도 즐거운 하루 보내세요!",
    "안녕하세요. 샌디매니저입니다. 요청하신 사항에 대해 온도조절하였습니다. 조금만 기다리시면 금방 시원해지실거에요. 오늘도 즐거운 하루 보내세요!",
    "안녕하세요. 샌디매니저입니다. 요청하신 사항에 대해 온도조절하였습니다. 조금만 기다리시면 금방 따듯해지실거에요. 오늘도 즐거운 하루 보내세요!",
    "안녕하세요. 샌디매니저입니다. 위험사항에 대해 신속히 확인하고 처리하도록 하겠습니다. 안전한 공간을 위해 더욱 노력하겠습니다. 감사합니다.",
  ];

  useEffect(() => {
    if (editMode) {
      const index = feedbackList.findIndex((example) => example === feedback);
      if (index !== -1) {
        setFeedbackIndex(index);
      } else {
        setFeedbackIndex(feedbackList.length);
      }
    }
  }, [editMode]);

  return (
    <div className="flex flex-col gap-1">
      {editMode === true ? (
        <>
          {feedbackList.map((feedback, index) => (
            <div
              key={index}
              className={clsx([
                "p-3 text-sm",
                {
                  " bg-brand-neutral-05": index !== feedbackIndex,
                  " bg-brand-category_tag font-semibold":
                    index === feedbackIndex,
                },
              ])}
              onClick={() => {
                if (feedbackIndex !== index) {
                  onChange(feedback);
                  setFeedbackIndex(index);
                } else {
                  onChange("");
                  setFeedbackIndex(-1);
                }
              }}
            >
              {feedback}
            </div>
          ))}
          <CommonButton
            variant="tertiary"
            onClick={() => {
              setFeedbackIndex(feedbackList.length);
              onChange("");
            }}
            className={clsx([
              {
                " bg-brand-primary-gray-100 border-brand-primary-gray-100 text-white font-medium":
                  feedbackIndex === feedbackList.length,
              },
            ])}
          >
            직접 작성
          </CommonButton>
          <CommonTextArea
            value={feedback}
            onChange={(e) => onChange(e.target.value)}
            disabled={feedbackIndex !== feedbackList.length}
            placeholder="피드백을 선택 또는 입력해주세요"
          />
        </>
      ) : (
        <div
          className={clsx(["p-3 text-sm bg-brand-category_tag font-semibold"])}
        >
          {feedback}
        </div>
      )}
    </div>
  );
}
